/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AdminIcon.vue?vue&type=template&id=666e7b42"
import script from "./AdminIcon.vue?vue&type=script&lang=js"
export * from "./AdminIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('666e7b42')) {
      api.createRecord('666e7b42', component.options)
    } else {
      api.reload('666e7b42', component.options)
    }
    module.hot.accept("./AdminIcon.vue?vue&type=template&id=666e7b42", function () {
      api.rerender('666e7b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/AdminIcon.vue"
export default component.exports